var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M0 0h34v24H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "scale(.02941 .04167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "b",
    width: 34,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAYCAYAAACfpi8JAAAABHNCSVQICAgIfAhkiAAAAwlJREFUSEvNlUtMU0EYhc9wy23LbWkpxVAEtZVHwBBBigGtCSpQiyZAgLjQlSaKCS4koC504cI1xoUJS3fuXIiyNwaQSKRqiY8ALUQetVC4QGl7H2PusHIH5i46y8nMmS//f84/xOfra8q1CkOKQmt2dpLIz8+FKCYgSTJsNgGqqmJraxc5OUYYDBy8iyF4E8vQa1FKwwaqdJKA/8Hn42WHa1LJNObnV9DYWIVQKIxkMg2PxwVJUrC4GEVBgR0Wiwklke/wWWS9OPZ0KKbJ/cFhGgzOwunMRZ7DioVIFOm0jJaWOoyMjCMnxwSvtwITEzNIpST03rqM7i6fviAASFvgIXU4rJAVFWsxEW5PIZZ+x9hDNpuFtUYUd2AyG2Hks9FU7kRbvUd/kOvXnlJFUcHzBiQSKeTlWbC0tIaiIic2NnbAcQRGYzbErQQMHIeq2SDqU3/0B7nTO0Sj0TgEixlcVhZkWUE8vo3qajfzigZYXFzA/KOqFK0lZjSXOvQHaW0ZpK6ifEhpGSsr66isOoJIeJX5xOVyQKtWNLoBu12AyWTEpeZadHee1R/kbt9zOje3DLvdwiKqVWN7excNDZUYGwvBZOJRUVGMb6EIFFmB30nQVMjrD9LT84RarWYQEMRim3C7XQiHlyEIZvA8B0oJkskUSBYBz2fDE/qEemnPzHou0tH+mGpmBAGrxKECO1ZX4xAEE9sDJVAUBSqlbKC1ed244qvQk4Fpkf7+F/RLcA5Opw1ajBcWNH8ouHCxBqPvJlm7TtWVYfLjD6TTEm7f8KOr/Yz+IM0XB2htbSmrxsxMBIHAaUxN/cTamoi6unI2xLT0uD0u2G0CcsffowGb+oP4WwZYa7R0aOPcbObZPyPLKjMqpZTBaDEmhKAhNova3VX9QcSNLXoQVQMoOHqgK/uSJ+vTX/VX3dfT/x4iozXnMwNk6t6jzABJbYqZAfJr+GVmgLw9cS4zQMKvXmcGiJTYzQyQD1dvhgFy9D+ir+MVGiRvjnmbaBZ5BoKTOirvX4rSCKeSjr+3KUZa7riV3gAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlag);
export default __webpack_public_path__ + "static/media/icon-flag.af5272495acc9f1d6ff1f8db8ca58911.svg";
export { ForwardRef as ReactComponent };